/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filecategoryphoto2Inputs */

const en_filecategoryphoto2 = /** @type {(inputs: Filecategoryphoto2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo`)
};

const pt_filecategoryphoto2 = /** @type {(inputs: Filecategoryphoto2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto`)
};

/**
* | output |
* | --- |
* | "Photo" |
*
* @param {Filecategoryphoto2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filecategoryphoto2 = /** @type {((inputs?: Filecategoryphoto2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filecategoryphoto2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filecategoryphoto2(inputs)
	return pt_filecategoryphoto2(inputs)
});
export { filecategoryphoto2 as "fileCategoryPhoto" }